export default "__VITE_ASSET__CV$oTUvD__"